<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Tryout</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Tryout</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tablatihan" data-toggle="tab">Latihan Soal</a>                                                
											</li> 
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tablatihan" class="tab-pane fade show active">
                                             <div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            <div class="form-group card-label">
                                                                <v-select
                                                                :options="lsthakakses"
                                                                :reduce="lsthakakses => lsthakakses.id" 
                                                                label="nama"
                                                                v-model="id_group_user"
                                                                placeholder="Silahkan pilih Grup User"
                                                                required
                                                                />
                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Lihat Tugas </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0">
												<div class="card-body">
                             
                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl" @click="resetVar()">Tambah Latihan</a>
                                                    </div>
                                                    <!-- <vue-virtual-table
                                                        
                                                        :config="tableConfig"
                                                        :data="lsttryout"
                                                        :height="tableAttribute.height"
                                                        :itemHeight="tableAttribute.itemHeight"
                                                        :minWidth="tableAttribute.minWidth"
                                                        :selectable="tableAttribute.selectable"
                                                        :enableExport="tableAttribute.enableExport"
                                                        :bordered="tableAttribute.bordered"
                                                        :hoverHighlight="tableAttribute.hoverHighlight"
                                                        :language="tableAttribute.language"
                                                        v-on:changeSelection="handleSelectionChange"
                                                        v-on:click="handleClickRow"
                                                        v-on:contextmenu="handleContextmenu"
                                                    >
                                                        <template slot-scope="scope" slot="actionCommon">
                                                            <button class="btn btn-sm bg-success-light" depressed small @click="getTryout(scope.row)">
                                                                <i class="fas fa-eye"></i> Kerjakan
                                                            </button>
                                                            <button class="btn btn-sm bg-warning-light" depressed small @click="getHasilTryout(scope.row)">
                                                                <i class="fas fa-eye"></i> Hasil
                                                            </button>
                                                            <button class="btn btn-sm bg-info-light" depressed small @click="getDetail(scope.row)">
                                                                <i class="fas fa-eye"></i> Soal
                                                            </button>
                                                            <button class="btn btn-sm bg-warning-light" depressed small @click="getEdit(scope.row)">
                                                                <i class="fas fa-edit"></i> Edit
                                                            </button>
                                                            <button class="btn btn-sm bg-primary-light" depressed small @click="getCloning(scope.row)">
                                                                <i class="fas fa-edit"></i> Cloning
                                                            </button>
                                                            <button class="btn btn-sm bg-danger-light" depressed small @click="getDelete(scope.row)">
                                                                <i class="fas fa-times"></i> Delete
                                                            </button>
                                                            
                                                        </template>
                                                    </vue-virtual-table> -->

													<div class="table-responsive">
                                                        <table id="tblLatihan" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Tingkatan / Kategori / Subject</th>
                                                                    <th class="text-left">Paket Soal</th>
                                                                    <th class="text-left">Pembuat Soal</th>
                                                                    <th class="text-left">Jumlah Soal</th>
                                                                    <th class="text-left">Publish</th>
                                                                    <th class="text-left">Publish Pembahasan</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
                                                                    <td>{{ ref.nama_to }}</td>
                                                                    <td>{{ ref.nama_pembuat_to }}</td>
                                                                    <td class="text-center">{{ ref.jumlah_soal }}</td>
                                                                    <td>
                                                                        <span v-if="ref.fg_publish == '1'">Aktif</span>
                                                                        <span v-if="ref.fg_publish == '0'">Tidak Aktif</span>
                                                                    </td>
                                                                    <td>
                                                                        <span v-if="ref.is_active == '1'">Aktif</span>
                                                                        <span v-if="ref.is_active == '0'">Tidak Aktif</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getTryout(ref)">
                                                                            <i class="fas fa-eye"></i> Kerjakan
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getHasilTryout(ref)">
                                                                            <i class="fas fa-eye"></i> Hasil
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-info-light" depressed small @click="getDetail(ref)">
                                                                            <i class="fas fa-eye"></i> Soal
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getCloning(ref)">
                                                                            <i class="fas fa-edit"></i> Cloning
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
									
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="hasilMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hasil pengerjaan Tryout {{tryout.nama_to}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table id="tblHasil" class="table table-hover table-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-left">#</th>
                                        <th class="text-left">Tanggal</th>
                                        <th class="text-left">Nilai</th>
                                        <th class="text-left">Waktu</th>
                                        <th class="text-left">Action</th>
                                    </tr>
                                </thead>
            
                                <tbody>
                                    <tr v-for="(ref, index) in lsthasil" :key="ref.id_user_to">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ ref.created_date }}</td>
                                        <td class="text-center">{{ ref.hasil }}</td>
                                        <td class="text-center">{{ ref.waktu }}</td>
                                        <td>
                                            <v-btn class="btn btn-sm bg-success-light" depressed small @click="getPembahasan(ref)">
                                                <i class="fas fa-eye"></i> Pembahasan
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>                                            
                            </table>
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Latihan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Nama Paket Latihan <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="tryout.nama_to" required>
                            </div>
                            <div class="form-group">
                                <label>Tingkatan</label>
                                <v-select
                                :options="lsttingkatan"
                                :reduce="lsttingkatan => lsttingkatan.id_tingkatan" 
                                label="nama_tingkatan"
                                v-model="tryout.id_tingkatan"
                                @input="filterKategori"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Kategori</label>
                                <v-select
                                :options="lstmateri"
                                :reduce="lstmateri => lstmateri.id_materi" 
                                label="optmateri"
                                v-model="tryout.id_materi"
                                @input="filterSubject"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Subject</label>
                                <v-select
                                :options="lstsubject"
                                :reduce="lstsubject => lstsubject.id_sub_materi" 
                                label="nama_sub_materi"
                                v-model="tryout.id_sub_materi"
                                />
                            </div>
                            <div class="form-group">
                                <label>Waktu Pengerjaan (dalam menit)<span class="text-danger">*</span></label>
                                <input class="form-control" type="number" v-model="tryout.waktu" required>
                            </div>   
                            <div class="form-group">
                                <label>Max Pengerjaan</label>
                                <input class="form-control" type="number" v-model="tryout.is_periodik" required>
                            </div>   
                            <!-- <div class="form-group">
                                <label>Link Youtube Pembahasan Tryout</label>
                                <input class="form-control" type="text" v-model="tryout.youtube_id">
                            </div>                          -->
                            <div class="form-group">
                                <label>Status Tryout</label>
                                <v-select
                                :options="lststspublish"
                                :reduce="lststspublish => lststspublish.id" 
                                label="text"
                                v-model="tryout.fg_publish"
                                />                                
                            </div>                           
                            <div class="form-group">
                                <label>Status Pembahasan</label>
                                <v-select
                                :options="lststspublishpembahasan"
                                :reduce="lststspublishpembahasan => lststspublishpembahasan.id" 
                                label="text"
                                v-model="tryout.is_active"
                                />                                
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Mulai Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryout.start_date">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Akhir Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryout.end_date">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                <hr>
                                <div class="comp-header"><h3 class="comp-title">Youtube Pembahasan Tryout</h3> <div class="line"></div></div>
                                
                                        <input name=image type=file id="upload" onchange="" class="hidden">
                                        <tinymce
                                            api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                            :init="myInit"
                                            v-model="tryout.youtube_id"
                                            />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                <hr>
                                    <div class="table-responsive">		
                                            
                                        <h3>KATEGORI PASSING GRADE</h3>																
                                        <div class="col-auto text-right float-right ml-auto">
                                            <a href="#" class="btn btn-primary btn-sm" @click.prevent="addKategoriPg()">Tambah Kategori</a>
                                        </div>
                                        <table id="tbl" class="table table-hover table-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Nama Kategori</th>
                                                    <th>Passing Grade</th>
                                                    <th>Aksi</th>
                                                </tr>     
                                            </thead>
                                            <tbody>
                                                <tr v-for="(ref, index) in lstkategoripg" :key="ref">
                                                    <td class="text-center">{{ index + 1 }}</td>
                                                    <td><input class="form-control" type="text" v-model="ref.jns_kategori"></td>
                                                    <td><input class="form-control" type="number" v-model="ref.pg"></td>										
                                                    <td class="text-center">
                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteKategoriPg(index)">
                                                            <i class="fas fa-times"></i> Delete
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>  	
                                        </table>																	
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="form-group">
                                <label>Passing Grade TWK </label>
                                <input class="form-control" type="number" v-model="tryout.pg_twk">
                            </div>
                            <div class="form-group">
                                <label>Passing Grade TIU </label>
                                <input class="form-control" type="number" v-model="tryout.pg_tiu">
                            </div>
                            <div class="form-group">
                                <label>Passing Grade TKP </label>
                                <input class="form-control" type="number" v-model="tryout.pg_tkp">
                            </div> -->
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section">
                            <button class="btn btn-primary submit-btn" @click.prevent="save">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="cloningMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Cloning Latihan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Nama Paket Latihan <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="tryoutclon.nama_to" required>
                            </div>
                            <div class="form-group">
                                <label>Tingkatan</label>
                                <v-select
                                :options="lsttingkatan"
                                :reduce="lsttingkatan => lsttingkatan.id_tingkatan" 
                                label="nama_tingkatan"
                                v-model="tryoutclon.id_tingkatan"
                                @input="filterKategori"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Kategori</label>
                                <v-select
                                :options="lstmateri"
                                :reduce="lstmateri => lstmateri.id_materi" 
                                label="optmateri"
                                v-model="tryoutclon.id_materi"
                                @input="filterSubject"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Subject</label>
                                <v-select
                                :options="lstsubject"
                                :reduce="lstsubject => lstsubject.id_sub_materi" 
                                label="nama_sub_materi"
                                v-model="tryoutclon.id_sub_materi"
                                />
                            </div>
                            <div class="form-group">
                                <label>Waktu Pengerjaan (dalam menit)<span class="text-danger">*</span></label>
                                <input class="form-control" type="number" v-model="tryoutclon.waktu" required>
                            </div>    
                            <div class="form-group">
                                <label>Link Youtube Pembahasan Tryout</label>
                                <input class="form-control" type="text" v-model="tryoutclon.youtube_id">
                            </div>                            
                            <div class="form-group">
                                <label>Status</label>
                                <v-select
                                :options="lststspublish"
                                :reduce="lststspublish => lststspublish.id" 
                                label="text"
                                v-model="tryoutclon.fg_publish"
                                />                                
                            </div>                         
                            <div class="form-group">
                                <label>Status Pembahasan</label>
                                <v-select
                                :options="lststspublishpembahasan"
                                :reduce="lststspublishpembahasan => lststspublishpembahasan.id" 
                                label="text"
                                v-model="tryoutclon.is_active"
                                />                                
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Mulai Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryoutclon.start_date">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Akhir Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryoutclon.end_date">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section">
                            <button class="btn btn-primary submit-btn" @click.prevent="saveCloning">Simpan Cloning</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Paket Latihan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus latihan <b>{{ tryout.nama_to }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="kerjakanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hai, apakah kamu sudah siap mengerjakan Latihan ini?</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <br>
                        <table class="table">
                            <tr>
                                <td>Kategori</td>
                                <td>{{tryout.nama_materi}} / {{tryout.nama_sub_materi}}</td>
                            </tr>
                            <tr>
                                <td>Jumlah Soal</td>
                                <td>{{tryout.jumlah_soal}} Soal</td>
                            </tr>
                            <tr>
                                <td>Waktu Mengerjakan</td>
                                <td>{{tryout.waktu}} menit</td>
                            </tr>
                        </table>
                        <br>
                        <div role="alert" class="alert alert-warning">
                            <div class="col-auto">
                                <strong class="ml-0"><i class="fa fa-info-circle"></i> Perhatian!</strong><br>
                                <ol class="mb-0">
                                    <li>Gunakan browser Mozilla Firefox versi terbaru supaya website dapat diakses dengan lancar tanpa masalah.</li>
                                    <li>Pastikan tidak ada aktivitas login ke akun anda (pada perangkat lain) saat sedang mengerjakan tryout.</li>                       
                                </ol>
                            </div>
						</div>
                    </div>

                    <div class="modal-footer">                        
                        <button class="btn btn-rounded btn-primary" @click.prevent="doTryout()"><i class="fa fa-user-edit"></i> Kerjakan Sekarang</button>
                        
                    </div>

                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
import VueVirtualTable from 'vue-virtual-table';

export default {
    components: {
        Sidebar,
        VueVirtualTable
    },
	name: 'Materi',
    data() {
        return {
            // tableConfig: [
            //     { prop: '_index', name: '#', width: 80 },
            //     {
            //     prop: 'tingkatan_kat_subj',
            //     name: 'Tingkatan / Kategori / Subject',
            //     searchable: true,
            //     width:1000,
            //     justifyContent:'left'
            //     // summary: 'COUNT'
            //     // , sortable: true
            //     /*filterable: true*/ 
            //     },
            //     { prop: 'nama_to', name: 'Paket Soal', searchable: true, width:1000,justifyContent:'left'},
            //     { prop: 'nama_pembuat_to', name: 'Pembuat', filterable: true, width:400,alignItems:'left'},
            //     { prop: 'jumlah_soal', name: 'Jumlah Soal', sortable: true, width:250},
            //     { prop: 'lbl_fg_publish', name: 'Publish', filterable: true, width:500},
            //     { prop: 'lbl_is_active', name: 'Pembahasan', filterable: true, width:500},
            //     { prop: '_action', name: 'Action', actionName: 'actionCommon', width:1200}
            // ],
            // // tableData: [
            // //     { user: 'a1', age: 20, city: 'aaaa' },
            // //     { user: 'a2', age: 21, city: 'bbbb' },
            // //     { user: 'a3', age: 23, city: 'aaaa' }
            // // ],
            // tableAttribute: {
            //     height: 650,
            //     itemHeight: 90,
            //     // minWidth: 1000,
            //     // selectable: true,
            //     enableExport: true,
            //     bordered: true,
            //     hoverHighlight: true,
            //     language: "en"
            // },
            lsttryout: [],
            lstsubject: [],
            lsthasil:[],
            tryout: {
                id_to: '',
                nama_to: '',
                id_tingkatan: '',
                id_materi: '',
                id_sub_materi: '',
                url: '',
                waktu: '',
                fg_publish: '',
                start_date: '',
                end_date: '',
                is_active: '', created_by:'', created_by: '', youtube_id:'', is_periodik:0,
                // pg_twk:'', pg_tiu:'', pg_tkp:''
            },
            tryoutclon: {
                id_to: '',
                nama_to: '',
                id_tingkatan: '',
                id_materi: '',
                id_sub_materi: '',
                url: '',
                waktu: '',
                fg_publish: '',
                start_date: '',
                end_date: '',
                is_active: '', created_by:'', created_by: '', youtube_id:''
            },
            lstmateri: [],
            lstsubmateri: [],
            lsttingkatan: [],
            lststspublish: [
                {id: '1', text: 'Aktif'},
                {id: '0', text: 'Tidak Aktif'}
            ],
            lststspublishpembahasan: [
                {id: '1', text: 'Aktif'},
                {id: '0', text: 'Tidak Aktif'}
            ],
            id_group_user: '',
            lsthakakses: [
                {id: '3', nama: 'Administrator'},
                {id: '2', nama: 'Coach'}
            ], 
            lstkategoripg: [],           
            myInit: {
                height: 500,
                entity_encoding : 'raw',  
                paste_data_images: true,
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern'
                ],
                toolbar1: 'insertfile undo redo | formatselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                toolbar2: 'print preview media | forecolor backcolor emoticons tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
                external_plugins: {
                    tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
                    // 'tiny_mce_wiris': 'node_modules/@wiris/mathtype-tinymce4/plugin.min.js',
                },
                image_advtab: true,
                file_picker_callback: function(callback, value, meta) {
                    if (meta.filetype == 'image') {
                    $('#upload').trigger('click');
                    $('#upload').on('change', function() {
                        var file = this.files[0];
                        var reader = new FileReader();
                        reader.onload = function(e) {
                        callback(e.target.result, {
                            alt: ''
                        });
                        };
                        reader.readAsDataURL(file);
                    });
                    }
                },
                images_upload_handler: function(blobInfo, success, failure) {
                    let formreq = new FormData()
                    console.log("ini blobnya: ");
                    console.log(blobInfo.blob());
                    formreq.append('file', blobInfo.blob());
                    var instance = axiosTiny.create({ baseURL: 'https://api.pejuangpendidik.com/' });
                    instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    instance.post('api/uploadimg', formreq,
                        {
                            // headers: {
                            //     'Content-Type': 'multipart/form-data',
                            // },
                            transformRequest: (data, headers) => {
                                return formreq;
                            },
                        }) //this.$route.params.id)
                        .then(res => {
                            console.log(res.data.location);
                            if(res.status ==200){
                                if(res.data.location !=""){
                                    success(res.data.location);
                                } else {
                                    failure('gagal upload image'+ res.data.location);
                                }
                            } else {
                                failure('gagal upload image'+ res.data.location);
                            }
                        })
                        .catch(err => {
                            // handle error
                            console.log(err);
                        })
                },
                

            },
        }
    },
    created: function () {
        // this.getAll();
        this.getAllTingkatan();
        this.getAllMateri();
        this.getAllSubMateri();
    },  
    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },


        //--------------------------
        // Get Materi
        getAll: function () {
            
            axios.get('api/tryoutByGroup/'+this.id_group_user)
            // axios.get('api/tryoutAll')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLatihan");
                    this.lsttryout = res.data.data;
                    this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New Materi
        save: function () {
            axios.post('api/tryout', {
                    data: this.tryout,
					lstkategoripg: this.lstkategoripg,
                    // id_to: this.tryout.id_to,
                    // nama_to: this.tryout.nama_to,
                    // id_tingkatan: this.tryout.id_tingkatan,
                    // id_materi: this.tryout.id_materi,
                    // id_sub_materi: this.tryout.id_sub_materi,
                    // waktu: this.tryout.waktu,
                    // fg_publish: this.tryout.fg_publish,
                    // start_date: this.tryout.start_date,
                    // end_date: this.tryout.end_date,
                    // is_active: this.tryout.is_active
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

         // Create New Materi
        saveCloning: function () {
            axios.post('api/tryoutcloning', {
                    data: this.tryoutclon
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#cloningMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        filterKategori: function(value){
            this.tryout.id_materi = '';
            this.lstmateri = value? this.lstmateriori.filter(c => c.id_tingkatan == value) : this.lstmateriori;
        },
        
        filterSubject: function(value){
            this.tryout.id_sub_materi = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },


        resetVar: function(ref,isDasabled=false){
            if(ref){                
                this.tryout.id_to = ref.id_to;
                this.tryout.nama_to = ref.nama_to;
                this.tryout.id_tingkatan = ref.id_tingkatan;
                this.tryout.id_materi = ref.id_materi;
                this.tryout.id_sub_materi = ref.id_sub_materi;
                this.tryout.waktu = ref.waktu;
                this.tryout.youtube_id = ref.youtube_id;
                this.tryout.fg_publish = ref.fg_publish;
                this.tryout.is_active = ref.is_active;
                this.tryout.created_by = ref.created_by;
                this.tryout.created_date = ref.created_date;
				if(ref.list_kategori_pg) this.lstkategoripg = ref.list_kategori_pg;
				else this.lstkategoripg = [];
                // this.tryout.pg_twk = ref.pg_twk;
                // this.tryout.pg_tiu = ref.pg_tiu;
                // this.tryout.pg_tkp = ref.pg_tkp;
            } else {
                this.tryout.id_to = '';
                this.tryout.nama_to = '';
                this.tryout.id_tingkatan = '';
                this.tryout.id_materi = '';
                this.tryout.id_sub_materi = '';
                this.tryout.waktu = '';
                this.tryout.youtube_id = '';
                this.tryout.fg_publish = '';
                this.tryout.is_active = '1';
                this.tryout.created_by = '';
                this.tryout.created_date = '';
            }
            
            $("#frm input").prop("disabled", isDasabled);
            $("#frm v-select").prop("disabled", isDasabled);
        },

        // Get Detail and Show data to Modal
        getDetail: function (ref) {
            // nrouter.push("instructor/tryout/soal/"+ref.id_to);
            localStorage.removeItem('soal_id_soal');
            localStorage.setItem("soal_id_to", ref.id_to);      
            this.$router.push({name:'admin-tryout-soal'}); //, params: {id: ref.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        // Get Detail and Show data to Modal
        getTryout: function (ref) {
            this.tryout = ref;
            $("#kerjakanMdl").modal('show');            
            // this.$router.push({name:'admin-tryout-try', params: {id: ref.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

		 
        doTryout: function () {
            // this.tryout = ref;
            $("#kerjakanMdl").modal('hide');   
            localStorage.setItem("id_to", this.tryout.id_to);      
            localStorage.setItem("time", this.tryout.waktu*60);   
            const lstsoal = localStorage.getItem('lstsoal');
            if(lstsoal){
                localStorage.removeItem('lstsoal');
            }
            
            this.$router.push({name:'admin-tryout-try'});//, params: {id: this.tryout.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        getPembahasan: function (ref) {
            $("#hasilMdl").modal('hide');   
            localStorage.setItem("id_to", ref.id_to);      
            localStorage.setItem("id_user_to", ref.id_user_to);   
            
            this.$router.push({name:'admin-tryout-pembahasan'});
        },
 
        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },

        // getEdit: function (ref) {
        //     axios.get('api/tryout/'+ref.id_to)
        //         .then(res => {
        //             // this.tryout = res.data;
		// 			// this.lstkategoripg = res.list_kategori_pg;
        //             this.resetVar(res.data.data);
        //             $("#addMdl").modal('show');  					
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

        // Get Edit and Show data to Modal
        getCloning: function (ref) {
            this.tryoutclon = ref;
            $("#cloningMdl").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Materi
        hapus: function () {
            axios.post('api/tryoutdel', {
                    id_to: this.tryout.id_to
                })
                .then(res => {
                    // handle success
                    this.resetVar();
                    this.getAll();
                    $("#delMdl").modal('hide');

                    let timerInterval
                    swal.fire({
                    title: 'Hapus Tryout',
                    html: 'Tryout berhasil dihapus!',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        console.log('I was closed by the timer')
                    }
                    })
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        //--------------------------
        // Get Tingkatan
        getAllTingkatan: function () {
            axios.get('api/reftingkatan')
                .then(res => {
                    // console.log(res.data);
                    this.lsttingkatan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi
        getAllMateri: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    this.lstmateri = res.data.data;
                    this.lstmateriori = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get sub_materi
        getAllSubMateri: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getHasilTryout: function (ref) {
            axios.get('api/tryoutres/'+ref.id_to)
                .then(res => {
                    // console.log(res.data);
                    $("#hasilMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        addKategoriPg: function(){
			if(!Array.isArray(this.lstkategoripg)) this.lstkategoripg = [];
			this.lstkategoripg.push({ id_to:this.tryout.id_to, jns_kategori: '', pg:0 });
		},

		deleteKategoriPg: function(index){
			this.lstkategoripg.splice(index, 1);
		},
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Tryout/index.vue